'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { type CheckboxProps as RadixCheckboxProps } from '@radix-ui/react-checkbox';
import { useId } from 'react';
import { useSubscribedState } from '../../../hooks';
import { checkboxBoxVariants, CheckboxMark } from './checkboxVisuals';
interface CheckboxProps extends Omit<RadixCheckboxProps, 'checked' | 'disabled' | 'onCheckedChange'> {
  checked?: boolean;
  disabled?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}
const Checkbox = t0 => {
  const $ = _c(28);
  let checked;
  let className;
  let onCheckedChange;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      checked,
      disabled: t1,
      onCheckedChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = className;
    $[3] = onCheckedChange;
    $[4] = props;
    $[5] = t1;
  } else {
    checked = $[1];
    className = $[2];
    onCheckedChange = $[3];
    props = $[4];
    t1 = $[5];
  }
  const disabled = t1 === undefined ? false : t1;
  const [turned, setTurned] = useSubscribedState(checked ?? false);
  const isInnerHandled = typeof checked !== "boolean";
  const id = useId();
  let t2;
  if ($[6] !== className) {
    t2 = cn("flex items-start gap-4 p-4", "cursor-pointer whitespace-pre-wrap break-keep font-400 typo-body4", "text-Gray-900", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = isInnerHandled ? turned : checked;
  let t4;
  if ($[8] !== disabled || $[9] !== turned) {
    t4 = cn("m-2", checkboxBoxVariants({
      checked: turned,
      disabled,
      interactive: true
    }));
    $[8] = disabled;
    $[9] = turned;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isInnerHandled || $[12] !== onCheckedChange || $[13] !== setTurned) {
    t5 = state => {
      const checked_0 = state.valueOf();
      if (typeof checked_0 !== "boolean") {
        throw new Error("checked is not boolean");
      }
      onCheckedChange?.(checked_0);
      if (isInnerHandled) {
        setTurned(checked_0);
      }
    };
    $[11] = isInnerHandled;
    $[12] = onCheckedChange;
    $[13] = setTurned;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <RadixCheckbox.Indicator forceMount={true} className={cn("flex transition-opacity duration-150 motion-reduce:transition-none", "data-[state=checked]:opacity-100 data-[state=unchecked]:opacity-0")}><CheckboxMark /></RadixCheckbox.Indicator>;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== disabled || $[17] !== id || $[18] !== props || $[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t7 = <RadixCheckbox.Root id={id} checked={t3} className={t4} disabled={disabled} onCheckedChange={t5} {...props}>{t6}</RadixCheckbox.Root>;
    $[16] = disabled;
    $[17] = id;
    $[18] = props;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== id || $[24] !== props.children || $[25] !== t2 || $[26] !== t7) {
    t8 = <label htmlFor={id} className={t2}>{t7}{props.children}</label>;
    $[23] = id;
    $[24] = props.children;
    $[25] = t2;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
};
export { Checkbox, type CheckboxProps };